<div class="accordion-container">
  <div class="content" #element>
    <kion-accordion
      [items]="[{key: component.title, value: component.content}]"
    ></kion-accordion>
  </div>
</div>
